/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";

import Button from "../elements/Button";

export default function BrandIcon() {
  return (
    <Button className="" type="link" href="/">
      <p className="text-theme-blue text-4xl font-medium ">
        We
        <span className="text-theme-purple">Mente</span>
        <span className="text-amber-600">AI</span>
      </p>
    </Button>
  );
}
